<template>
    <div>
        <v-row align="center" class="mb-3">
            <v-col cols="12" md="2">
                <v-btn @click="openAddDialog()" color="secondary--text primary" large class="btn">
                    <v-icon class="ml-2">add_circle_outline</v-icon>
                    <h3>إضافة {{this.$route.meta.single}}</h3>
                </v-btn>
            </v-col>
            <v-spacer />
            <v-col cols="12" md="3">
                <v-text-field
                    v-debounce:500ms="getItems"
                    class="mr-1"
                    v-model="$global.state.filter.search"
                    label="الإسم"
                    hide-details
                    prepend-inner-icon="search"
                    dense
                    outlined
                    filled
                />
            </v-col>
        </v-row>
        <v-card id="card">
            <v-data-table
                class="mytable"
                :items="$global.state.readyResponses"
                :loading="$global.state.loading"
                :headers="headers"
                :search="$global.state.filter.search"
                hide-default-footer
                loading-text="جاري تحميل البيانات"
                no-data-text="لا توجد بيانات"
                :id="$vuetify.theme.dark ? 'row_colors_dark' : 'row_colors_light'"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event">

                <template v-slot:item.id="{ item }">
                    <span>{{ $global.state.readyResponses.indexOf(item) + 1 }}</span>
                </template>
               
                <template v-slot:item.created="{ item }">
                    <div>{{new Date(item.created).toISOString().substring(0,10)}}</div>
                </template>

                <template v-slot:item.actions="{item, index}">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click.stop="deleteItem(item.id, index,)" v-on="on" icon>
                                <v-icon color="error">delete</v-icon>
                            </v-btn>
                        </template>
                        <span>حذف</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click.stop="openEditDialog(item)" v-on="on" icon>
                                <v-icon color="info">edit</v-icon>
                            </v-btn>
                        </template>
                        <span>تعديل</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>
       <div class="d-flex justify-space-between py-3">
            <v-spacer></v-spacer>
            <v-pagination v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
        </div>
        <Dialog />
    </div>
</template>

<script>
export default {
    components: {
        Dialog: () => import("./dialog"),
    },
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                {
                    text: "#",
                    value: "id",
                },
                {
                    text: "عنوان",
                    value: "title",
                },
                {
                    text: "نص الرد",
                    value: "content",
                },
                {
                    text: "تاريخ الإضافة",
                    value: "created",
                },
                {
                    text: "الإجراءات",
                    value: "actions",
                    sortable: false,
                    align: "center",
                },
            ],
        };
    },

    mounted() {
        this.getItems();
        this.$eventBus.$on(`refresh`, () => {
            this.getItems();
        });
    },

    beforeDestroy() {
        this.$eventBus.$off(`refresh`);
    },

    methods: {
        getItems() {
            this.$global.dispatch(
                `get${this.$route.meta.endPoint}`,
                this.$route.meta.role
            );
        },

        async deleteItem(id, i) {
            this.$genericService.swalAlertConfirm({}).then((result) => {
                if (result.isConfirmed) {
                    this.$genericService
                        .delete(`${this.$route.meta.endPoint}`, id)
                        .then((res) => {
                            // this.$genericService.swalAlertSuccess();
                            this.$store.dispatch("toastification/setToast", {
                                message: `${res.data.message}`,
                                type: "success",
                            });
                            this.$global.state.readyResponses.splice(i, 1);
                        })
                        .catch((err) => {
                            this.$store.dispatch("toastification/setToast", {
                                message: `${err.data.message}`,
                                type: "error",
                            });
                        });
                }
            });
        },

        openAddDialog() {
            var item = {
                dialogType: "add",
            };
            this.$store.commit("setItemDetails", item);
            this.$store.commit("setDialog");
        },

        openEditDialog(item) {
            item.dialogType = "edit";
            this.$store.commit("setItemDetails", item);
            this.$store.commit("setDialog");
            this.$eventBus.$emit("fill-fields");
        },
    },
};
</script>
